















import { Vue, Component, Prop } from "vue-property-decorator";
import { VIPProject, VipProjectStatus } from '@/loader';

@Component
export default class ProjectStatusBadge extends Vue {
	@Prop({ type: VIPProject, required: true })
	public item!: VIPProject;

	@Prop({ type: Boolean, default: false })
	public hideText!: boolean;

	@Prop({ type: Boolean, default: false })
	public hideIcon!: boolean;

	@Prop({ type: Boolean, default: false })
	public button!: boolean;

	@Prop({ type: [String, Object], default: null })
	public to!: string | Location | null;

	public get statusVariant(): string {
		switch (this.item?.status) {
			case VipProjectStatus.bid:
				return "outline-primary";
			case VipProjectStatus.signed:
				return "outline-success";
			case VipProjectStatus.cancelled:
				return "outline-danger";
			case VipProjectStatus.ended:
			case VipProjectStatus.archived:
			default:
				return "success";
		}
	}

	public get icon(): string | string[] | null {
		switch (this.item?.status) {
			case VipProjectStatus.archived:
			case VipProjectStatus.ended:
			case VipProjectStatus.signed:
				return ["fas", "check"];
			case VipProjectStatus.cancelled:
				return ["far", "minus-circle"];
			case VipProjectStatus.bid:
			default:
				return ["fas", "edit"];
		}
	}
}
